<template slot-scope="scope">
  <!-- 绑定/更换银行卡 -->
      <dialogModel
        :title="PopUpTitle"
        :visible="dialogVisible"
        @handleClose="handleCancel"
        @handleOk="handleVerify"
      >
        <div class="dialog-content" v-if="type=='1'">
            是否删除该管理者，删除后该管理者不可登录本企业后台管理系统？
          </div>
          <div class="dialog-content" v-if="type=='2'">
            是否拒绝该申请者成为企业管理员？
          </div>
          <div class="dialog-content" v-if="type=='3'">
            是否通过该申请者成为企业管理员？
          </div>
      </dialogModel>
</template>

<script>
// 在弹窗中获取验证码 destroyed中的应写在handleClose/handleUnderstand中才生效
export default {
  props: {
    dialogVisible: {},
    PopUpTitle: {},
    type:{},  // 1删除   2拒绝  3同意
  },
  components: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  destroyed() {},
  methods: {
    // 取消
    handleCancel() {
        this.$emit("handleCancel" , this.type);
    },
    //确认
    handleVerify() {
        this.$emit("handleVerify" , this.type);
    },
  },
};
</script>

<style scoped lang="less">
.dialog-title {
  width: 100%;
  height: 60px;
  .off {
    width: 100%;
    height: 28px;
    display: flex;
    justify-content: flex-end;
    div {
      width: 18px;
      height: 18px;
      background-image: url("../../../../../assets/imgs/guanbi.svg");
      background-size: 100% 100%;
      margin-top: 15px;
    }
  }
  p {
    width: 100%;
    height: 28px;
    line-height: 28px;
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #409eff ;
    text-align: center;
    font-weight: 400;
  }
}
.dialog-content {
    font-size: 16px;
    margin: auto;
}
/deep/.el-button {
  width: 120px !important;
  height: 40px !important;
}
.el-button--primary {
  background: #409eff ;
  border: 1px solid #409eff ;
}
</style>
